// extracted by mini-css-extract-plugin
module.exports = {"container-input-format-number":"input-format-number_container-input-format-number__3XXwr","input":"input-format-number_input__2w8ld"};